import { useState, useEffect, useRef, useCallback } from 'react';

export default function useInfiniteScroll(items = [], pageSize = 12) {
  const [visibleCount, setVisibleCount] = useState(pageSize);
  const sentinelRef = useRef(null);

  const visibleItems = items.slice(0, visibleCount);
  const hasMore = visibleCount < items.length;

  const loadMore = useCallback(() => {
    if (hasMore) setVisibleCount((c) => Math.min(c + pageSize, items.length));
  }, [hasMore, pageSize, items.length]);

  useEffect(() => {
    setVisibleCount(pageSize);
  }, [items, pageSize]);

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el || !hasMore) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) loadMore(); },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [loadMore, hasMore]);

  return { visibleItems, hasMore, loadMore, sentinelRef };
}
